import React from 'react';

import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function Actions() {
  return (
    <div>
      <Spacing type="margin" size="l" position="bottom">
        <a href="mailto:security@marvelapp.com" className="display-block">
          <Button size="large" fullWidth>
            Speak to the security team
          </Button>
        </a>
      </Spacing>
      {/*
      <Spacing type="margin" size="l" position="bottom">
        <a href="ggekge" className="display-block">
          <Button size="large" fullWidth>
            Download our security paper
          </Button>
        </a>
      </Spacing>*/}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/security/Actions.js